import Cookies from 'js-cookie';

let popup = document.querySelector('.js-email-popup');
let closeButton = popup.querySelector('.js-email-popup-close');
let form = popup.querySelector('.js-email-popup-form');
let className = 'is-visible';

let cookieName = 'email-popupv2';

export function init() {
	let cookie = Cookies.get(cookieName);

	if (cookie || Cookies.get('cookie_consent') === undefined) {
		return;
	}

	window.addEventListener('scroll', onScroll);

	closeButton.addEventListener('click', () => handleCloseClick(7));

	form.addEventListener('submit', () => handleCloseClick(365));

	function handleCloseClick(expiry) {
		popup.classList.remove(className);
		window.removeEventListener('scroll', onScroll);
		Cookies.set(cookieName, 'true', { expires: expiry });
	}

	function onScroll() {
		let viewportHeight = (document.height !== undefined) ? document.height : document.body.offsetHeight;
		let viewportScrollableHeight = viewportHeight - window.innerHeight;

		let scrollPosition = window.scrollY;

		if (scrollPosition >= viewportScrollableHeight * 0.70) {
			popup.classList.add(className);
		}
	}
}
